/* eslint-disable no-console */
import { ZodError, z } from 'zod';

const envVariablesSchema = z.object({
  VITE_API_URL: z.string().url(),
  VITE_API_DOMAIN: z.string(),
  VITE_APP_NAME: z.string(),
  VITE_FRONTEND_CORE_HOSTNAME: z.string(),
  VITE_APP_TENANT: z.string(),
});

// eslint-disable-next-line import/no-mutable-exports
let env: z.infer<typeof envVariablesSchema>;

try {
  env = envVariablesSchema.parse(import.meta.env);
} catch (err) {
  console.error(
    'Env vars is invalid, check schema in the "@/shared/lib/env.ts!!!!!"'
  );

  if (err instanceof ZodError) {
    console.error(err.errors);
  }

  env = envVariablesSchema.parse({
    VITE_API_URL: 'http://localhost:8000',
    VITE_API_DOMAIN: 'localhost',
    VITE_APP_NAME: 'Pro-Bit',
    VITE_FRONTEND_CORE_HOSTNAME: 'app.localhost',
    VITE_SENTRY_DSN: 'string',
    VITE_APP_TENANT: 'probit',
  });
}

export { env };
